import { DataBean } from "../DataBean";

export class PaymentAccountitems extends DataBean {


    public async setPaymentAccountItemValue(idPaymentAccountItem:any,value:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "documents.PaymentAccountItem_setPaymentAccountItemValue_Number_Number", [idPaymentAccountItem,value]);
    }

 
}